<template>
    <svg
        viewBox="0 0 62 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="62"
        height="48">
        <g clip-path="url(#clip0_834_812)">
            <path
                d="M2.19114 16.7459C0.89562 17.1086 0 18.2895 0 19.6348V28.3652C0 29.7105 0.895621 30.8914 2.19114 31.2541L58.1911 46.9336C60.1041 47.4692 62 46.0312 62 44.0447V3.95534C62 1.96882 60.1041 0.530835 58.1911 1.06644L2.19114 16.7459Z"
                fill="#743FDA" />
            <path
                d="M19.8962 16.8755C17.6382 16.8755 15.8018 18.7226 15.8018 20.9936V29.8284H18.6836V20.9936C18.6836 20.3212 19.2273 19.7741 19.8962 19.7741C20.5642 19.7741 21.1082 20.3212 21.1082 20.9936H23.9901C23.9901 18.7227 22.1534 16.8755 19.8962 16.8755H19.8962Z"
                fill="#FEFEFE" />
            <path
                d="M10.1163 21.7348C10.7849 21.7348 11.3287 22.2817 11.3287 22.954H14.2107C14.2107 20.6832 12.3741 18.8359 10.1163 18.8359C7.85891 18.8359 6.02246 20.6832 6.02246 22.954V24.2068C6.02246 26.4777 7.85891 28.3253 10.1163 28.3253C12.3741 28.3253 14.2107 26.4777 14.2107 24.2068H11.3287C11.3287 24.8792 10.7849 25.4261 10.1163 25.4261C9.44811 25.4261 8.90427 24.8793 8.90427 24.2068V22.954C8.90427 22.2817 9.44811 21.7348 10.1163 21.7348Z"
                fill="#FEFEFE" />
            <path
                d="M45.971 10.7832C44.4036 10.7832 43.0402 11.6748 42.3522 12.9798C41.8368 12.744 41.2667 12.609 40.6647 12.609C38.4066 12.609 36.5703 14.4565 36.5703 16.7271V34.0942H39.4522V16.7271C39.4522 16.0549 39.9957 15.508 40.6648 15.508C41.3326 15.508 41.8767 16.0549 41.8767 16.7271V34.0942V35.9203H44.7587V34.0942V16.7271V14.9014C44.7587 14.229 45.302 13.682 45.9711 13.682C46.6391 13.682 47.1829 14.229 47.1829 14.9014V37.7463H50.065V14.9014C50.065 12.6305 48.2283 10.7832 45.971 10.7832H45.971Z"
                fill="#FEFEFE" />
            <path
                d="M30.835 28.2512C30.835 28.9235 30.2913 29.4703 29.6226 29.4703C28.954 29.4703 28.41 28.9235 28.41 28.2512V18.9184C28.41 18.2461 28.954 17.6989 29.6226 17.6989C30.2913 17.6989 30.835 18.2461 30.835 18.9184V28.2512ZM29.6226 14.8003C27.3649 14.8003 25.5283 16.6476 25.5283 18.9184V28.2512C25.5283 30.522 27.3649 32.3693 29.6226 32.3693C31.8801 32.3693 33.7167 30.522 33.7167 28.2512V18.9184C33.7167 16.6476 31.8801 14.8003 29.6226 14.8003Z"
                fill="#FEFEFE" />
            <path
                d="M53.1494 8.93359V11.3886H56.0311V8.93359H53.1494Z"
                fill="#FEFEFE" />
            <path
                d="M53.1494 39.2401H56.0311V12.6416H53.1494V39.2401Z"
                fill="#FEFEFE" />
        </g>
        <defs>
            <clipPath id="clip0_834_812">
                <rect
                    fill="white"
                    width="62"
                    height="48" />
            </clipPath>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
